function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.05015 4.18666C1.09008 4.06558 1.1525 3.95473 1.23248 3.85906C1.32335 3.75006 1.43314 3.66501 1.55343 3.6051C1.67276 3.54543 1.80568 3.50893 1.94631 3.50148C1.96814 3.50029 1.99001 3.49982 2.0119 3.50006H21.9882C22.0102 3.49982 22.0321 3.5003 22.054 3.50149C22.3239 3.51621 22.5861 3.63968 22.7699 3.86182C22.8469 3.95455 22.9074 4.06141 22.947 4.17793C22.9839 4.28608 23.0013 4.39853 23.0001 4.51032V12.0001C23.0001 12.5523 22.5523 13.0001 22.0001 13.0001C21.4478 13.0001 21.0001 12.5523 21.0001 12.0001V6.50006L12.6001 12.8001C12.2445 13.0667 11.7556 13.0667 11.4001 12.8001L3.00006 6.50006V18.5001H12.0001C12.5523 18.5001 13.0001 18.9478 13.0001 19.5001C13.0001 20.0523 12.5523 20.5001 12.0001 20.5001H2.00006C1.44777 20.5001 1.00006 20.0523 1.00006 19.5001V4.51001C0.998897 4.40133 1.01538 4.29202 1.05015 4.18666ZM5.00006 5.50006L12.0001 10.7501L19.0001 5.50006H5.00006Z",
  fill: "#28B704"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6248 14.2192C23.056 14.5642 23.1259 15.1935 22.7809 15.6247L18.7809 20.6247C18.4359 21.056 17.8066 21.1259 17.3754 20.7809L14.8754 18.7809C14.4441 18.4359 14.3742 17.8066 14.7192 17.3753C15.0642 16.9441 15.6935 16.8742 16.1248 17.2192L17.8439 18.5945L21.2192 14.3753C21.5642 13.9441 22.1935 13.8742 22.6248 14.2192Z",
  fill: "#28B704"
});

var SvgEmailSuccess = function SvgEmailSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmailSuccess.349d701e.svg";
export { ForwardRef as ReactComponent };